module.exports = __webpack_public_path__ + "img/if_6.286b0528.png";